<div class="relative flex flex-col min-h-screen">
  <div
    class="absolute inset-0 w-full h-full bg-center bg-cover -z-10"
    style="background-image: url('assets/images/slide3.jpg')"
  >
    <div class="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
  </div>

  <div class="flex flex-col min-h-screen bg-transparent relative z-10">
    <div class="sticky top-0 z-20 w-full">
      <div class="w-full">
        <app-top-nav-bar
          [fullWidth]="true"
          [isLanding]="true"
        ></app-top-nav-bar>
      </div>
    </div>

  

    <div
      class="flex flex-wrap gap-8 justify-center items-start w-full mt-72 px-8 pb-12 overflow-y-auto"
    >
      @for (landing of menuOptions; track landing; let i = $index) {
      <div
        *ngxPermissionsOnly="landing?.permission"
        [routerLink]="landing?.pathRoute"
        [queryParams]="landing?.queryParams ?? landing?.queryParams"
        [ngClass]="[
          'cursor-pointer shadow-md rounded-2xl p-6 flex flex-col items-start w-80 h-62 border transition-transform duration-500',
          'hover:shadow-xl hover:scale-105',
          i === 1 ? 'border-primary bg-gray-200' : 'border-gray-200 bg-white',
          'opacity-0 transform animate-fade-slide'
        ]"
        [style.animationDelay]="i * 100 + 'ms'"
      >
        <!-- Icon -->
        <div
          class="w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-r from-primary to-secondary mb-4 shadow-lg"
        >
          <mat-icon
            color="white"
            svgIcon="{{ landing.icon }}"
            class="text-white text-3xl"
          ></mat-icon>
        </div>

        <!-- Text -->
        <p class="text-left text-black font-bold text-lg mb-2">
          {{ landing.name | translate }}
        </p>
        <p class="text-left font-medium text-sm text-gray-500">
          {{ landing.description | translate }}
        </p>
      </div>
      }
    </div>
  </div>
</div>
